import axios from 'axios';
import baseUrl from './common';


/**
 * getUserInfo -获取用户信息
 * method get
 */
export const getUserInfo = () => axios({
    url: `${baseUrl}/api/user/info`,
    method: 'get',
});


/**
 * changePsd - 修改用户密码
 * @param  {any} parmas - password & new_pwd & judge_pwd
*/
export const changePsd = (parmas:any) => axios({
    url: `${baseUrl}/api/user/password`,
    method: 'post',
    data: parmas,
});

/**
 * changeCompany - 修改企业信息
 * @param  {any} parmas  - company & company_url
 */
export const changeCompany = (parmas:any) => axios({
    url: `${baseUrl}/api/user/company`,
    method: 'post',
    data: parmas,
});
/**
 * changeContact - 修改联系人信息
 * @param  {any} parmas
 */
export const changeContact = (parmas:any) => axios({
    url: `${baseUrl}/api/user/contact`,
    method: 'post',
    data: parmas,
});

/**
 * uploadCompanyLicense 上传营业执照
 * @param  {any} parmas  - company_license
 */
export const uploadCompanyLicense = (parmas:any) => axios({
    url: `${baseUrl}/api/user/upload_license `,
    method: 'post',
    data: parmas,
});

/**
 * deleteCompanyLicense - 删除营业执照
 * @param  {any} parmas - path
 */
export const deleteCompanyLicense = (parmas:any) => axios({
    url: `${baseUrl}/api/user/delete_license `,
    method: 'post',
    data: parmas,
});

/**
 * checkOldPwd - 校验旧密码
 * @param  {any} parmas
 */
export const checkOldPwd = (parmas:any) => axios({
    url: `${baseUrl}/api/user/old_password`,
    method: 'post',
    data: parmas,
});
